function normalizedIdentityPart(value) {
  return String(value || "").trim().replace(/\s+/g, " ");
}

function identityKey(value) {
  return normalizedIdentityPart(value).toLocaleLowerCase();
}

export function staffDisplayNameTracksCanonicalIdentity(profile = {}) {
  const firstName = normalizedIdentityPart(profile.first_name);
  const lastName = normalizedIdentityPart(profile.last_name);
  const displayName = normalizedIdentityPart(profile.display_name);
  const fullName = [firstName, lastName].filter(Boolean).join(" ");
  return !displayName || identityKey(displayName) === identityKey(firstName)
    || identityKey(displayName) === identityKey(fullName);
}

export function canonicalStaffDisplayName(profile = {}) {
  const firstName = normalizedIdentityPart(profile.first_name);
  const lastName = normalizedIdentityPart(profile.last_name);
  const displayName = normalizedIdentityPart(profile.display_name);
  if (!displayName || /^(owner|owner account)$/i.test(displayName)) {
    const fullName=[firstName,lastName].filter(Boolean).join(" ");
    return /^(owner|owner account)$/i.test(fullName)?"":fullName;
  }
  if (firstName && lastName && identityKey(displayName) === identityKey(firstName)) {
    return `${displayName} ${lastName}`;
  }
  return displayName;
}

export function displayNameForStaffIdentityUpdate(existing = {}, next = {}) {
  const requested = {
    first_name: next.first_name ?? existing.first_name,
    last_name: next.last_name ?? existing.last_name,
    display_name: next.display_name ?? existing.display_name,
  };
  if (Object.prototype.hasOwnProperty.call(next, "display_name")) {
    return canonicalStaffDisplayName(requested);
  }
  if (staffDisplayNameTracksCanonicalIdentity(existing)
      && (Object.prototype.hasOwnProperty.call(next, "first_name")
        || Object.prototype.hasOwnProperty.call(next, "last_name"))) {
    return [normalizedIdentityPart(requested.first_name), normalizedIdentityPart(requested.last_name)]
      .filter(Boolean).join(" ");
  }
  return canonicalStaffDisplayName(requested);
}

// Legacy bootstrap role labels are not human identities. SQL projections use
// the same boundary without changing persisted authors or signed snapshots.
export function canonicalStaffDisplayNameSql(alias, fallback="'Staff member'") {
  if(!/^[a-z_][a-z0-9_]*$/i.test(alias))throw new Error("invalid_staff_identity_alias");
  const clean=value=>`CASE WHEN lower(trim(COALESCE(${value},''))) NOT IN ('','owner','owner account') THEN trim(${value}) END`;
  return `COALESCE(${clean(`${alias}.display_name`)},${clean(`concat_ws(' ',${alias}.first_name,${alias}.last_name)`)},${fallback})`;
}

export function canonicalActorDisplayNameSql(userAlias, staffAlias) {
  if(!/^[a-z_][a-z0-9_]*$/i.test(userAlias))throw new Error("invalid_actor_identity_alias");
  const fullName=`NULLIF(trim(concat_ws(' ',${userAlias}.first_name,${userAlias}.last_name)),'')`;
  const person=`CASE WHEN lower(${fullName}) NOT IN ('owner','owner account') THEN ${fullName} END`;
  return `CASE WHEN ${userAlias}.id IS NULL THEN 'System' ELSE ${canonicalStaffDisplayNameSql(staffAlias,`COALESCE(${person},'Staff member')`)} END`;
}
